import React from "react";
import "./HomeSpread.css";
import { Link } from "react-router-dom";
import raccoon_img from "../Assets/plant_thief_raccoon.png";

const HomeSpread = () => {
  return (
    <div className="homespread">
      <div className="homespread-left">
        <h1>embrace the absurdity.</h1>
        <Link to="/stickers" style={{ textDecoration: "none" }}><button className="button">...and dive in ★</button></Link>
      </div>
      <div className="homespread-right">
        <img src={raccoon_img} alt="" />
      </div>
    </div>
  );
};

export default HomeSpread;
